import React, { Component } from 'react'

import Menu from './Menu'
import SliderBrand from './SliderBrand'
import Casos from './Casosrel'
import Dest from './DestBrand'
import RedSocial from './redsocial'
import Contact from './contact'
import MailSuscriptionContent from './Mailsuscription';

import { connect } from 'react-redux'
import {
    initLocation,
    initCategories,
    initPostAsync,
    initPostCountryAsync,
    initMenuAsync,
    order,
    filter,
    PostPageAsync,
    PostCategoryAsync,
    PostCategoryCountryAsync,
    initPostClear,
    PostbyTagSlug } from './actions'


class App extends Component {
  constructor(props){
    super(props)
    this.state = {
      postObj:[],
      menu:[],
      domain: window.location.hostname,
      logo: `${window.location.hostname}/wp-content/themes/beisbolplay/images/logo.png`,
      menuSel:'menu-int',
      defaultCountry: 9,
      selectDest: [],
      selectBrand: [],
      selectCase: []
    }
  }

  componentDidMount(){
    this.props.getLocation()
    this.props.getMenuInit()
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      let nameMenu = `menu-${next_props.country.idtag.slug}`
      let idCo = next_props.country.idtag.term_id
      this.setState({
        country: next_props.country.location,
        menuSel: nameMenu,
        defaultCountry: idCo,
        selectDest: [],
        selectBrand: [],
        selectCase: []
      })
      this.props.clearPost()
      this.props.getCategorybyCountry(12, next_props.country.idtag.term_id)
      this.props.getCategorybyCountry(13, next_props.country.idtag.term_id)
      this.props.getCategorybyCountry(25, next_props.country.idtag.term_id)
    }

    if(next_props.post !== this.state.postObj){

      let destdata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(25) !== -1
      })

      destdata = destdata.sort(function(a, b){return b.order - a.order})

      destdata = destdata.reverse();

      this.setState({
          selectDest: destdata
        })

      let casedata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(13) !== -1
      })

      casedata = casedata.sort(function(a, b){return b.date-a.date})

      casedata = casedata.slice(0, 7)

      this.setState({
        selectCase: casedata
      });

      let branddata = next_props.post.filter((itemdata) => {
        return itemdata.categories.indexOf(12) !== -1
      })

      branddata = branddata.sort(function(a, b){return b.id-a.id})

      this.setState({
        selectBrand: branddata
      });


    }
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <div className="">
            <div className="row">
              <div className="col s12 m11 offset-m1 l9 offset-l3 logo ">
                <Contact search={false}/>
                <RedSocial search={true}/>
                <Menu slug='locations' select={true} col={12} scrollMenu={false} changeGeo={true} defCountry={this.state.defco}/>
              </div>
              <div className="col s12 m12 l12 nav_principal">
                <Menu slug={this.state.menuSel}  col={12} scrollMenu={true} injectMenu={true}/>
              </div>
            </div>
          </div>
        </header>
        <section>
          <div className="dest-case">
            <Dest content={this.state.selectDest} />
          </div>
          <div className="cont_slider_brand">
            <div className="container">
              <div className="row">
                <div className="col s12">
                  <SliderBrand content={this.state.selectBrand}/>
                </div>
              </div>
            </div>
          </div>
          <div className="col s12 bg_case">
            <div className="container">
              <div className="title-container">
                <h2>Campañas destacadas en la región</h2>
              </div>
              {/* <Casos content={this.state.selectCase}/> */}
              <Casos post={(this.state.selectCase)?this.state.selectCase :[] }/>
              <div className="row">
                <div className="col s12 offset-m4 m4 offset-l4 l4 content-suscrition-mail">
                  <MailSuscriptionContent />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="line_bg"></div>
          <div className="cont_log_footer">
            <div className="container">
              <div className="row">
                <div className="col s12 m7 text_vc">
                  <p>COPYRIGHT @ VC MEDIOS S.A. 2018 > TODOS LOS DERECHOS RESERVADOS</p>
                  <p><a href="/terminos-y-condiciones-politica-de-privacidad/">TERMINOS Y CONDICIONES</a> | <a href="/terminos-y-condiciones-politica-de-privacidad/">POLITICAS DE PRIVACIDAD</a></p>
                </div>
                <div className="col s12 m5 brand_vc">
                  <img className="col s6" src="/assets/images/logo_vc_footer_b.png"  alt=""/>
                  <img className="col s6" src="/assets/images/logo_vcDigital_footer_b.png"  alt=""/>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps (reducer){
  return {
    pageTotal: reducer.page,
    post: reducer.post,
    menus: reducer.menus,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getAllCategoryInit: (data) => dispatch(initCategories(data)),
    getAllPostInit: (data) => dispatch(initPostAsync(data)),
    getAllPostbyCountryInit: (data, excludeContry) => dispatch(initPostCountryAsync(data, excludeContry)),
    getPagePost: (data, exclude) => dispatch(PostPageAsync(data, exclude)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
    getCategory: (data) => dispatch(PostCategoryAsync(data)),
    getCategorybyCountry: (data, excludeCountry) => dispatch(PostCategoryCountryAsync(data, excludeCountry)),
    filterBy: (data) => dispatch(filter(data)),
    orderBy: (data) => dispatch(order(data)),
    getAllTagsbySlug: (data) => dispatch(PostbyTagSlug(data)),
    clearPost: (data) => dispatch(initPostClear(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(App)



// WEBPACK FOOTER //
// ./src/Home.js